import * as React from 'react';

import { SearchField } from '@rematter/ui-web';
import { useSetAtom } from 'jotai';

import * as state from '../../../_state/itemAliasesList.state';
import { useTranslations } from '../../../i18n/useTranslations';

import { useDebouncedAtom } from '~/shared/hooks/useDebouncedAtom';

export const ItemAliasesFilters = () => {
  const t = useTranslations();
  const [searchTerm, setSearchTerm] = useDebouncedAtom(state.$searchTerm, 300);
  const setOffset = useSetAtom(state.$offset);

  const handleSearchChange = React.useCallback(
    (value: string) => {
      setSearchTerm(value);
      setOffset(0);
    },
    [setSearchTerm, setOffset],
  );

  return (
    <SearchField
      autoFocus
      value={searchTerm ?? ''}
      onChange={handleSearchChange}
      placeholder={t.inventoryView.itemAliasesPanel.search.placeholder}
      aria-label={t.inventoryView.itemAliasesPanel.search.ariaLabel}
      className="@ItemAliasesFilters w-[200px] shrink-0"
    />
  );
};
